module.exports = __webpack_public_path__ + "img/app_channel_product_col3_1.jpg";